import React from "react";
import type { CaseStudyContent } from "../../data/caseStudies";
import { Prose } from "./Prose";
import { BODY, H2, H3 } from "../../utils/typography";
type ChallengeSolutionProps = {
  challenge: CaseStudyContent["challenge"];
  solution: CaseStudyContent["solution"];
};
export function ChallengeSolution({
  challenge,
  solution
}: ChallengeSolutionProps) {
  const blocks = [{
    title: "The Challenge",
    data: challenge,
    bg: "bg-espresso"
  }, {
    title: "The Solution",
    data: solution,
    bg: "bg-rust"
  }];
  return <section aria-label="Challenge and solution" className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6" data-id="element-31" data-mp="3i4wtj28w9rfe">
      {blocks.map(block => <div key={block.title} className={`flex flex-col rounded-3xl p-8 md:p-12 ${block.bg}`} data-id="element-32" data-mp="394zxgfk6dqab">
          <h2 className={`${H2} text-mustard`} data-id="element-33" data-mp="397cl99cm6uva">
            {block.title}
          </h2>
          <p className={`mt-6 ${H3} text-cream`} data-id="element-34" data-mp="1bd49bg3341yq">
            {block.data.headline}
          </p>
          <div className="mt-6" data-id="element-35" data-mp="17biv9retdhmy">
            <Prose body={block.data.body} className={`${BODY} text-cream/80`} emphasisClassName={`${H3} text-mustard`} data-id="element-36" data-mp="2nwtzre8d4ocd" />
          </div>
        </div>)}
    </section>;
}